export const isObject = ( o ) => toString.call( o ) === '[object Object]';

export const getDependenciesForHook = p => {

	if ( !Array.isArray( p )) return []

	return p.reduce(( all_params, current ) => {

		const parse = c => {
			isObject( c ) 
				? Object.values( c ).forEach( p => parse( p ))
				: all_params.push( c )
		}
		
		parse( current );
		return all_params;
	}, [])
}

export const filterArrByRegExp = ( arr, search_str, param_name = "" ) => {
	return arr.filter( i => {
		
		const item = param_name ? i[ param_name ] : i;

		const reg_exp = new RegExp( search_str.trim().replace(/[-\/\\^$*+?.()|[\]{}]/gi, "\\$&" ), "gi" )
		return reg_exp.test( String( item ))
	})
}

export const getDebounceFn = ( fn, delay = 300 ) => {

	let timer;

	return function( ...args ) {

		clearTimeout( timer ); 	
		timer = setTimeout(() => {
			fn && fn( ...args )
		}, delay )
	}
}

export const cutText = ( text, size ) => {
	if ( text.length <= size ) return text;
	return text.slice( 0, size - 3 ) + "...";
}

export const toggleArrValue = ( value, arr ) => {
	return arr.includes( value )
		? arr.filter( v => v !== value )
		: [...arr, value ]
}

export const collectRespFormErrors = ( e ) => {

   const errors = {};
   const resp_data = e?.response?.data?.errors || e?.response?.data?.data;
   if ( !resp_data ) return {};

   Object.keys( resp_data ).forEach( k => {
      if ( !Array.isArray( resp_data[ k ])) return;
      errors[ k ] = resp_data[k]?.join("\n");
   });

   return errors;
}

export const generateAndDownloadFile = ( data, file_name, type ) => {
	
	const blob = new Blob([ data ], { type: type || "application/octet-stream" });
   const url = window.URL.createObjectURL( blob );
   const a = document.createElement( "a" );
    
	a.setAttribute( "href", url );
   a.setAttribute( "download", file_name );
 	a.click();

	window.URL.revokeObjectURL( url );
}

export const downloadBase64Png = ( base64String, fileName = 'downloaded_image.png' ) => {
    
   const base64Data = base64String.replace(/^data:image\/(png|jpeg|gif|webp);base64,/, '');

   const byteCharacters = atob(base64Data);
   const byteNumbers = new Array(byteCharacters.length);
   for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
   }

   const byteArray = new Uint8Array( byteNumbers );
   generateAndDownloadFile( byteArray, fileName, "image/png" );
}